/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertyRightAnswersDto } from './PropertyRightAnswersDto';
import {
    PropertyRightAnswersDtoFromJSON,
    PropertyRightAnswersDtoFromJSONTyped,
    PropertyRightAnswersDtoToJSON,
    PropertyRightAnswersDtoToJSONTyped,
} from './PropertyRightAnswersDto';
import type { AssetPropertyRightRequest } from './AssetPropertyRightRequest';
import {
    AssetPropertyRightRequestFromJSON,
    AssetPropertyRightRequestFromJSONTyped,
    AssetPropertyRightRequestToJSON,
    AssetPropertyRightRequestToJSONTyped,
} from './AssetPropertyRightRequest';

/**
 * 
 * @export
 * @interface SavePropertyRightsRequest
 */
export interface SavePropertyRightsRequest {
    /**
     * 
     * @type {PropertyRightAnswersDto}
     * @memberof SavePropertyRightsRequest
     */
    answers: PropertyRightAnswersDto;
    /**
     * 
     * @type {Array<AssetPropertyRightRequest>}
     * @memberof SavePropertyRightsRequest
     */
    propertyRights: Array<AssetPropertyRightRequest>;
}

/**
 * Check if a given object implements the SavePropertyRightsRequest interface.
 */
export function instanceOfSavePropertyRightsRequest(value: object): value is SavePropertyRightsRequest {
    if (!('answers' in value) || value['answers'] === undefined) return false;
    if (!('propertyRights' in value) || value['propertyRights'] === undefined) return false;
    return true;
}

export function SavePropertyRightsRequestFromJSON(json: any): SavePropertyRightsRequest {
    return SavePropertyRightsRequestFromJSONTyped(json, false);
}

export function SavePropertyRightsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavePropertyRightsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': PropertyRightAnswersDtoFromJSON(json['answers']),
        'propertyRights': ((json['propertyRights'] as Array<any>).map(AssetPropertyRightRequestFromJSON)),
    };
}

export function SavePropertyRightsRequestToJSON(json: any): SavePropertyRightsRequest {
    return SavePropertyRightsRequestToJSONTyped(json, false);
}

export function SavePropertyRightsRequestToJSONTyped(value?: SavePropertyRightsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answers': PropertyRightAnswersDtoToJSON(value['answers']),
        'propertyRights': ((value['propertyRights'] as Array<any>).map(AssetPropertyRightRequestToJSON)),
    };
}

